// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Product extends TrackingModel {
	public ProductId: number = 0;
	public ProductCategoryId?: number;
	public Name: string = "";
	public Description?: string;
	public Pitch?: string;
	public AvatarBlobPath?: string;
}